module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$auth.check()) ? [_c('private-header'), _vm._v(" "), _c('challenge-box')] : _vm._e(), _vm._v(" "), _c('alerts'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('all-modals'), _vm._v(" "), _c('transition', {
    attrs: {
      "leave-to-class": "fadeOut",
      "leave-active-class": "animated"
    }
  }, [(_vm.global_loading || !_vm.$auth.ready()) ? _c('div', {
    staticClass: "site-loading app-loader"
  }) : _vm._e()]), _vm._v(" "), _c('app-offline'), _vm._v(" "), _c('app-feedback')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 352
// module chunks = 9